import React from 'react';

import './template.scss';

export default class Template extends React.Component {
  render() {
    return (
      <div className="aboutus-template">

        <div className="page-header">
          <h1>{this.props.title}</h1>
          <div className="header-separator"></div>
        </div>


        <div className="container">
          <div className="row">
            <div className=" col-sm-11 col-xs-16 wider-gap-col-sm ">
              <div className="body-copy">
                {this.props.children}
              </div>
            </div>
          </div>
        </div>

        <div className="spacer-2">&nbsp;</div>

      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/about-us/template.js